module.exports = __webpack_public_path__ + "static/img/204.5933b09d.jpg";